import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/doc-headshot.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/hcp-banner.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/hear-your-peers-callout.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/help-patients-callout.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/learn-about-advanced-wound-care-callout.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/logo-organogenesis.svg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/OrganogenesisCorpLogo_OMark_Final_RGB.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/images/patiens-are-looking-banner-background.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/svg/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/svg/OrganogenesisCorpLogo_Final_KO_RGB.svg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/public/svg/request-rep.svg");
;
import(/* webpackMode: "eager", webpackExports: ["FormButton"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/_libs/components/form-button/form-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/hcp/libs/sections/hcp-form/hcp-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HCPThoughtsCarousel"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/hcp/libs/sections/hcp-thoughts/libs/components/hcp-thoughts-coursel/hcp-thoughts-coursel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoThoughtsCarouselMobile"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/hcp/libs/sections/hcp-thoughts/libs/components/video-thoughts-carousel-mobile/video-thoughts-carousel-mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoThoughtsCarousel"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/hcp/libs/sections/hcp-thoughts/libs/components/video-thoughts-carousel/video-thoughts-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AsideNavigator"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/aside-navigator/aside-navigator.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCopyright"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/footer/libs/components/footer-copyright/footer-copyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferToApligraphBlock"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/footer/libs/components/refer-to-apligraph-block/refer-to-apligraph-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTopButton"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/footer/libs/components/scroll-to-top-button/scroll-to-top-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyRecaptcha"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/lazy-recaptcha/lazt-recaptcha.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/react-query-provider/react-query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/libs/components/tooltip/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/alert-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/aspect-ratio.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/checkbox.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/command.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/data-table.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/field.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/popover.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/radio-group.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/select.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/switch.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-shadcn-ui/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useMediaQuery"] */ "/opt/atlassian/pipelines/agent/build/libs/shared/shared-utils/src/lib/use-media-query.ts");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next-image-export-optimizer/dist/ExportedImage.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
